<template>
  <section class="vehicle-page-faq">
    <div class="vehicle-page-faq__title-wrap">
      <h2 class="vehicle-page-faq__title">{{ title }}</h2>
    </div>
    <div class="vehicle-page-faq__accordion">
      <button
        v-for="(item, index) in items"
        :key="index"
        type="button"
        class="vehicle-page-faq__item"
        :aria-expanded="isOpen(index)"
        @click="toggle(index)"
      >
        <div class="vehicle-page-faq__divider" />
        <div class="vehicle-page-faq__question">
          <span class="vehicle-page-faq__question-text">{{ item.question }}</span>
          <QIcon :name="isOpen(index) ? evaExpandLess : evaExpandMore" size="28px" class="vehicle-page-faq__icon" />
        </div>
        <div v-show="isOpen(index)" class="vehicle-page-faq__answer">
          <p class="vehicle-page-faq__answer-text" v-html="item.answer"></p>
        </div>
      </button>
    </div>
    <div class="vehicle-page-faq__divider vehicle-page-faq__divider--last" />
  </section>
</template>

<script>
import { QIcon } from 'quasar';
import { evaArrowIosDownward, evaArrowIosUpward } from '@quasar/extras/eva-icons';

export default {
  name: 'VehiclePageFaq',
  components: {
    QIcon
  },
  props: {
    title: {
      type: String,
      default: 'Frequency asked questions'
    },
    items: {
      type: Array,
      default: () => []
    },
    defaultOpenIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    const open = [];
    if (this.defaultOpenIndex >= 0) {
      open.push(this.defaultOpenIndex);
    }
    return {
      openIndices: open
    };
  },
  created() {
    this.evaExpandMore = evaArrowIosDownward;
    this.evaExpandLess = evaArrowIosUpward;
  },
  methods: {
    isOpen(index) {
      return this.openIndices.includes(index);
    },
    toggle(index) {
      if (this.isOpen(index)) {
        this.openIndices = this.openIndices.filter((i) => i !== index);
      } else {
        this.openIndices = [...this.openIndices, index];
      }
    }
  }
};
</script>
